import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { ILookupSite } from '../../../../Models/ILookupSite';
import { LookupService } from 'src/app/Services/LookupService';
import { FormAuthorizationForDisclosureService } from "../../../../Services/FormAuthorizationForDisclosureService";
import { IFormAuthorizationForDisclosure } from "../../../../Models/Forms/IFormAuthorizationForDisclosure";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';

@Component({
  selector: 'AuthorizationForDisclosure',
  templateUrl: './AuthorizationForDisclosure.component.html',
  styleUrls: ['./AuthorizationForDisclosure.component.css']
})

export class FormAuthorizationForDisclosure extends SpinnerBase implements OnInit {

  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  panel1: boolean;
  panel2: boolean;
  panel3: boolean;
  panel4: boolean;
  panelNumber: number = 1;
  yearInTheFutureDate: Date;
  formAuthorizationForDisclosureDB: any = [];
  lookupSite: any = [];
  lookupSiteName: string;
  lookupSiteAddress: string;
  lookupSiteList: ILookupSite[];
  _lookupService: LookupService;
  reportParamArray: IReportParameter[];
  checkedTrue: boolean = true;
  checkedFalse: boolean = false
  meetingDate: Date;
  fapeEndDate: Date;
  //public showSpinner: boolean = false;

  constructor(
    private globals: Globals,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router,
    lookupService: LookupService, reportService: ReportService,
    private _formAuthorizationForDisclosureService: FormAuthorizationForDisclosureService) {
    super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
    this.successMessages = [];
    this.errorMessages = [];
  }


  ngOnInit(): void {
    this.LoadFormAuthorizationForDisclosureDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.scrollToTop();
    this.yearInTheFutureDate = new Date();
    this.yearInTheFutureDate.setDate(this._myGlobals.todaysDate.getDate() + 365);
    this.meetingDate = this._myGlobals.selectedIepInstance.meetingDate;
    this.fapeEndDate = new Date(this.meetingDate.getFullYear() + 1, this.meetingDate.getMonth(), this.meetingDate.getDate() - 1);
  }


  LoadFormAuthorizationForDisclosureDetails(): void {
    this._formAuthorizationForDisclosureService.getFormAuthorizationForDisclosure(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormAuthorizationForDisclosure) => {
        this.formAuthorizationForDisclosureDB = res,
          this.formAuthorizationForDisclosureDB.DateSigned = new Date(this.formAuthorizationForDisclosureDB.DateSigned);
        this.DisplayPanels()
      },
        err => console.error(err)
      );
  }

  DisplayPanels(): void {
    this.panel2 = true
    this.panel3 = true
    this.panel4 = true
    this.panelNumber == 1
    if (this.formAuthorizationForDisclosureDB.disclosingParty2 == null &&
      this.formAuthorizationForDisclosureDB.receivingParty2 == null &&
      this.formAuthorizationForDisclosureDB.disclosingAddress2 == null &&
      this.formAuthorizationForDisclosureDB.receivingAddress2 == null &&
      this.formAuthorizationForDisclosureDB.disclosingCityStateZip2 == null &&
      this.formAuthorizationForDisclosureDB.receivingCityStateZip2 == null &&
      this.formAuthorizationForDisclosureDB.disclosingTelephone2 == null &&
      this.formAuthorizationForDisclosureDB.receivingTelephone2 == null &&
      this.formAuthorizationForDisclosureDB.disclosingFax2 == null &&
      this.formAuthorizationForDisclosureDB.receivingFax2 == null) {
      this.panel2 = false;
      this.panelNumber = 2;
    }
    if (this.formAuthorizationForDisclosureDB.disclosingParty3 == null &&
      this.formAuthorizationForDisclosureDB.receivingParty3 == null &&
      this.formAuthorizationForDisclosureDB.disclosingAddress3 == null &&
      this.formAuthorizationForDisclosureDB.receivingAddress3 == null &&
      this.formAuthorizationForDisclosureDB.disclosingCityStateZip3 == null &&
      this.formAuthorizationForDisclosureDB.receivingCityStateZip3 == null &&
      this.formAuthorizationForDisclosureDB.disclosingTelephone3 == null &&
      this.formAuthorizationForDisclosureDB.receivingTelephone3 == null &&
      this.formAuthorizationForDisclosureDB.disclosingFax3 == null &&
      this.formAuthorizationForDisclosureDB.receivingFax3 == null) {
      this.panel3 = false
      if (this.panelNumber == 1){
        this.panelNumber = 3;
      }
    }
    if (this.formAuthorizationForDisclosureDB.disclosingParty4 == null &&
      this.formAuthorizationForDisclosureDB.receivingParty4 == null &&
      this.formAuthorizationForDisclosureDB.disclosingAddress4 == null &&
      this.formAuthorizationForDisclosureDB.receivingAddress4 == null &&
      this.formAuthorizationForDisclosureDB.disclosingCityStateZip4 == null &&
      this.formAuthorizationForDisclosureDB.receivingCityStateZip4 == null &&
      this.formAuthorizationForDisclosureDB.disclosingTelephone4 == null &&
      this.formAuthorizationForDisclosureDB.receivingTelephone4 == null &&
      this.formAuthorizationForDisclosureDB.disclosingFax4 == null &&
      this.formAuthorizationForDisclosureDB.receivingFax4 == null) {
      this.panel4 = false
      if (this.panelNumber == 1) {
        this.panelNumber = 4;
      }
    }
  }

  UpdatePanelsInfo() {
    if (this.panel4 == false) {
      this.formAuthorizationForDisclosureDB.disclosingParty4 = null;
      this.formAuthorizationForDisclosureDB.receivingParty4 = null;
      this.formAuthorizationForDisclosureDB.disclosingAddress4 = null;
      this.formAuthorizationForDisclosureDB.receivingAddress4 = null;
      this.formAuthorizationForDisclosureDB.disclosingCityStateZip4 = null;
      this.formAuthorizationForDisclosureDB.receivingCityStateZip4 = null;
      this.formAuthorizationForDisclosureDB.disclosingTelephone4 = null;
      this.formAuthorizationForDisclosureDB.receivingTelephone4 = null;
      this.formAuthorizationForDisclosureDB.disclosingFax4 = null;
      this.formAuthorizationForDisclosureDB.receivingFax4 = null;
    }
    if (this.panel3 == false) {
      this.formAuthorizationForDisclosureDB.disclosingParty3 = null;
      this.formAuthorizationForDisclosureDB.receivingParty3 = null;
      this.formAuthorizationForDisclosureDB.disclosingAddress3 = null;
      this.formAuthorizationForDisclosureDB.receivingAddress3 = null;
      this.formAuthorizationForDisclosureDB.disclosingCityStateZip3 = null;
      this.formAuthorizationForDisclosureDB.receivingCityStateZip3 = null;
      this.formAuthorizationForDisclosureDB.disclosingTelephone3 = null;
      this.formAuthorizationForDisclosureDB.receivingTelephone3 = null;
      this.formAuthorizationForDisclosureDB.disclosingFax3 = null;
      this.formAuthorizationForDisclosureDB.receivingFax3 = null;
    }
    if (this.panel2 == false) {
      this.formAuthorizationForDisclosureDB.disclosingParty2 = null;
      this.formAuthorizationForDisclosureDB.receivingParty2 = null;
      this.formAuthorizationForDisclosureDB.disclosingAddress2 = null;
      this.formAuthorizationForDisclosureDB.receivingAddress2 = null;
      this.formAuthorizationForDisclosureDB.disclosingCityStateZip2 = null;
      this.formAuthorizationForDisclosureDB.receivingCityStateZip2 = null;
      this.formAuthorizationForDisclosureDB.disclosingTelephone2 = null;
      this.formAuthorizationForDisclosureDB.receivingTelephone2 = null;
      this.formAuthorizationForDisclosureDB.disclosingFax2 = null;
      this.formAuthorizationForDisclosureDB.receivingFax2 = null;
    }
  }

  addMoreInfoRows() {
    if (this.panel2 == false) {
      this.panel2 = true
      this.panelNumber = 3
    }
    else if (this.panel3 == false) {
      this.panel3 = true
      this.panelNumber = 4
    }
    else if (this.panel4 == false) {
      this.panel4 = true
    }
  }

  removeMoreInfoRows() {
    if (this.panel4 == true) {
      this.panel4 = false
      this.panelNumber = 4
    }
    else if (this.panel3 == true) {
      this.panel3 = false
      this.panelNumber = 3
    }
    else if (this.panel2 == true) {
      this.panel2 = false
      this.panelNumber = 2
    }
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  //Save the conference Invitation
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;
    this.UpdatePanelsInfo();

    //update values
    this._formAuthorizationForDisclosureService.insertUpdateFormAuthorizationForDisclosure(this.formAuthorizationForDisclosureDB)
      .subscribe((res: IFormAuthorizationForDisclosure) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.LoadFormAuthorizationForDisclosureDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormAuthorizationForDisclosureDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.formAuthorizationForDisclosureDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: 'True' },
      { parameterName: 'FormInstanceID', parameterValue: this.formAuthorizationForDisclosureDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: '' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'IEPID', parameterValue: this.formAuthorizationForDisclosureDB.iepId.toString() },
      //{ parameterName: 'ReportPath', parameterValue: '' }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    //this.controlplPrintSpinner(true);
    this.printFormCommon(this.formAuthorizationForDisclosureDB.rdlFileNameEnglish, this.reportParamArray);
    //this.controlplPrintSpinner(false);
  }

  printSpanish() {
    this.populateReportParameters();
    //this.controlplPrintSpinner(true);
    this.printFormCommon(this.formAuthorizationForDisclosureDB.rdlFileNameSpanish, this.reportParamArray);
    //this.controlplPrintSpinner(false);
  }

  //controlPrintSpinner(showSpinner: boolean) {
  //  this.showSpinner = showSpinner;
  //}


}
